module.exports = __webpack_public_path__ + "static/christ-b5a187ee9d69e54de598f1a110c4d332.png";